import { AxiosInstance } from "axios";
import { CrossSellResponse } from "../steps/cross-sell";

export const crossSellPaths = {
  getProductsByApplication: (applicationId: string) => `/onboarding-applications/${applicationId}/cross-sell/products`,
};

class CrossSellApi {
  api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this.api = api;
  }

  getProductsByApplication = (applicationId: string) => {
    return this.api.get<CrossSellResponse>(crossSellPaths.getProductsByApplication(applicationId));
  };
}

export default CrossSellApi;